import { TestData as AnimalData } from './animalData'; // Adjust the import path as needed
import { Pens, TestData as PenData } from './lf_Data'

// Define the structure of a Section 
export interface Section {
  id: number; 
  pens: Pens[]
}

// Sample data: List of sections with their animals
export const Sections: Section[] = [
  { 
    id: 1,
    pens: PenData.filter(pen => [301, 302, 303, 304, 305, 306, 307, 308, 309, 310, 311, 312, 313, 314, 315, 316].includes(pen.penId))
  },
  { 
    id: 2,
    pens: PenData.filter(pen => [317, 318, 319, 320, 321, 322, 323, 324, 325, 326, 327, 328, 329, 330, 331, 332].includes(pen.penId))
  },
  { 
    id: 3,
    pens: PenData.filter(pen => [333, 334, 335, 336, 337, 338, 339, 340, 341, 342, 343, 344, 345, 346, 347, 348].includes(pen.penId))
  }
];

// Function to get a section by ID
export function getSectionById(sectionId: number) {
  const section = Sections.find(section => section.id === sectionId);

  if (!section) return null;

  // Get detailed animal data for each pen in the section
  const pensWithAnimals = section.pens.map(pen => {
    // Find the corresponding animal based on pen's animal number
    const animalData = AnimalData.find(animal => animal.animalId === pen.animalId);

    return {
      ...pen,
      animal: animalData ? animalData : null // Add the animal data to the pen
    };
  });

  return {
    ...section,
    pens: pensWithAnimals // Return the section with pens including animal data
  };
}
